export function isMobileUserAgent(userAgent: string): boolean {
  return /Mobile|Android|iPhone|iPad|iPod|Windows Phone|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
    userAgent,
  );
}
